// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { RoutePatterns } from '../../../types/routes';

export default (pathname) => !!matchPath(pathname, { path: RoutePatterns.GRIDS });

export const isPool = (pathname) => !!matchPath(pathname, { path: RoutePatterns.POOL, exact: true });

export const isGridPublic = (pathname) => !!matchPath(pathname, { path: RoutePatterns.GRID_PUBLIC, exact: true });

export const isGridShare = (pathname) => !!matchPath(pathname, { path: RoutePatterns.GRID_SHARE, exact: true });

export const getPoolPathFromPublic = (pathname) => {
  const isPublic = isGridPublic(pathname);
  const array = pathname.split('/');
  if (isPublic) {
    array.pop();
    array.pop();
    return array.join('/');
  } else return '/grids';
};

export const isGridHistory = (pathname) => !!matchPath(pathname, { path: RoutePatterns.GRID_HISTORY, exact: true });
export const isGridHistoryDetail = (pathname) =>
  !!matchPath(pathname, { path: RoutePatterns.GRID_HISTORY_DETAIL, exact: true });

export const isGridsHistory = (pathname) => isGridHistory(pathname) || isGridHistoryDetail(pathname);

export const isGrids = (pathname) => !!matchPath(pathname, { path: RoutePatterns.GRIDS });

export const isGridHelpOpen = (location) => location.hash.indexOf('#help') === 0;
export const isGridStatsOpen = (location) => location.hash.indexOf('#stats') === 0;
export const isGridSystemDetailsOpen = (location) => location.hash.indexOf('#details') === 0;

export const isGridMobileModalOpen = (location) =>
  isGridHelpOpen(location) || isGridStatsOpen(location) || isGridSystemDetailsOpen(location);

export const isGridDesktopModalOpen = (location) => isGridHelpOpen(location) || isGridStatsOpen(location);
